import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./sections/Hero";
import About from "./sections/About";
import Programs from "./sections/Programs";
import Testimonials from "./sections/Testimonials";
import Give from "./sections/Give";
import Contact from "./sections/Contact";

const App = () => {
  return (
    <>
      <Header />
      <Home />
      <About />
      <Programs />
      <Testimonials />
      <Give />
      <Contact />
      <Footer /></>
  )
}

export default App